import React from 'react';
import { MISSED_PAYMENT_U18, MISSED_PAYMENT } from '.';
import { CopyText } from '@acorn-portal/shared/src/components/text';

type Handler = React.JSX.Element[];

const generateSectionWording = (
	sectionData: { [key: number]: string },
	Component: React.ComponentType<{ children: React.ReactNode }>,
) => {
	return Object.values(sectionData).map((text, index) => <Component key={index}>{text}</Component>);
};

export const ImportantSectionWordingU18 = generateSectionWording(MISSED_PAYMENT_U18.important, CopyText);
export const NextStepsSectionWordingU18 = generateSectionWording(MISSED_PAYMENT_U18.next, CopyText);

export const DescriptionSectionWording = (paymentPlanType: number, isYDScheme: boolean): Handler => {
	const MISSED_PAYMENT_SELECTION = isYDScheme ? MISSED_PAYMENT_U18 : MISSED_PAYMENT;
	return generateSectionWording(
		paymentPlanType === 1 ? MISSED_PAYMENT_SELECTION.description : MISSED_PAYMENT_SELECTION.descriptionV2,
		CopyText,
	);
};

export const ImportantSectionWording = (paymentPlanType: number, isYDScheme: boolean): Handler => {
	const MISSED_PAYMENT_SELECTION = isYDScheme ? MISSED_PAYMENT_U18 : MISSED_PAYMENT;
	return generateSectionWording(
		paymentPlanType === 1 ? MISSED_PAYMENT_SELECTION.important : MISSED_PAYMENT_SELECTION.importantV2,
		CopyText,
	);
};

export const NextStepsSectionWording = (
	paymentPlanType: number,
	isYDScheme: boolean,
	isPayInFull: boolean,
): Handler => {
	const MISSED_PAYMENT_SELECTION = isYDScheme ? MISSED_PAYMENT_U18 : MISSED_PAYMENT;
	let sectionData;
	if (paymentPlanType === 1) {
		sectionData = MISSED_PAYMENT_SELECTION.next;
	} else {
		if (isPayInFull) {
			sectionData = MISSED_PAYMENT_SELECTION.nextV2PayInFull;
		} else {
			sectionData = MISSED_PAYMENT_SELECTION.nextV2;
		}
	}
	return generateSectionWording(sectionData, CopyText);
};

export const ProceedSectionWording = (paymentPlanType: number, isYDScheme: boolean) => {
	const MISSED_PAYMENT_SELECTION = isYDScheme ? MISSED_PAYMENT_U18 : MISSED_PAYMENT;
	if (paymentPlanType === 1) {
		return (
			<>
				<CopyText>By proceeding, you are confirming:</CopyText>
				<ul>
					<li>{MISSED_PAYMENT_SELECTION.proceed[1]}</li>
					<li>{MISSED_PAYMENT_SELECTION.proceed[2]}</li>
				</ul>
				<br />
				<CopyText>{MISSED_PAYMENT_SELECTION.proceed[3]}</CopyText>
				<CopyText> {MISSED_PAYMENT_SELECTION.proceed[4]}</CopyText>
				<CopyText>{MISSED_PAYMENT_SELECTION.proceed[5]}</CopyText>
				<CopyText> {MISSED_PAYMENT_SELECTION.proceed[6]} </CopyText>
			</>
		);
	} else {
		return (
			<>
				<CopyText>By choosing this option you are confirming:</CopyText>
				<ul>
					<li>{MISSED_PAYMENT_SELECTION.proceedV2[1]}</li>
					<li>{MISSED_PAYMENT_SELECTION.proceedV2[2]}</li>
					<li>{MISSED_PAYMENT_SELECTION.proceedV2[3]}</li>
				</ul>
				<br />
				<CopyText> {MISSED_PAYMENT_SELECTION.proceedV2[4]}</CopyText>
				<CopyText>{MISSED_PAYMENT_SELECTION.proceedV2[5]}</CopyText>
				<CopyText>{MISSED_PAYMENT_SELECTION.proceedV2[6]} </CopyText>
			</>
		);
	}
};
